@if (!refreshing) {
  <div class="row ms-2 mt-2">
    @if (ineligibleCount > 0) {
      <nav class="nav nav-pills m-2">
        <a
          class="nav-item nav-link"
          href="#"
          (click)="navClick($event, true)"
          [class.active]="eligible === true"
          [class.disabled]="eligible === true"
          >
          Eligible Encounters <small>({{eligibleCount}})</small>
        </a>
        <a
          class="nav-item nav-link"
          href="#"
          (click)="navClick($event, false)"
          [class.active]="eligible === false"
          [class.disabled]="eligible === false"
          >
          Ineligible Encounters <small>({{ineligibleCount}})</small>
        </a>
      </nav>
    }
  </div>
  @if (encounters.length > 0) {
    <div>
      <div class="m{{ eligible ? 'eligible' : 'ineligible' }} t-2">
        <app-pagination-header [paging]="paging" [label]="'encounters'" (pageSizeChange)="onPageSizeChange($event)" />
      </div>
      @if (!refreshing) {
        <div class="mt-2">
          @if (tableTemplate) {
            <ng-container [ngTemplateOutlet]="tableTemplate" [ngTemplateOutletContext]="{ $implicit: encounters }" />
          } @else {
            <table class="table table-bordered table-hover">
              <thead class="table-dark">
                <tr>
                  <th>ID</th>
                  <th>EHR ID</th>
                  <th>PATIENT</th>
                  <th>DATE</th>
                  <th>PROVIDER</th>
                  <th>CLIENT</th>
                  <th>ENC-LOCATION</th>
                  <th>ENC-TYPE</th>
                </tr>
              </thead>
              <tbody>
                @for (encounter of encounters; track encounter) {
                  <tr>
                    <td>
                      {{ encounter.id }}
                    </td>
                    <td>
                      {{ encounter.ehrIdentifier }}
                    </td>
                    <td class="phi">
                      {{ encounter.patientFirst }} {{ encounter.patientLast }} ({{ encounter.patientDob | date: 'MM/dd/yyyy' }})
                    </td>
                    <td>
                      {{ encounter.encounterDate | date: 'MM/dd/yyyy' }}
                    </td>
                    <td>
                      {{ encounter.providerDisplayNameWithNpi }}
                    </td>
                    <td>
                      {{ encounter.client }}
                    </td>
                    <td>
                      {{ encounter.location }}
                    </td>
                    <td>
                      {{ encounter.encounterType }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }
          <div class="mt-2">
            <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
          </div>
        </div>
      }
    </div>
  } @else {
    <p class="ms-1">No {{ eligible ? 'eligible' : 'ineligible' }} encounters.</p>
  }
} @else {
  <mat-spinner />
}

